import DownloadRequestPage from '../../../../shared/reportDownloads/DownloadRequestPage'
import {DownloadRequestConfig} from '../../../../shared/reportDownloads/DownloadRequestConfig'

const config: DownloadRequestConfig = {
  isKpi: true,
  authPermission: 'kpi.export',
}

const ReportDownloadsKpiPage = () => <DownloadRequestPage config={config} />

export default ReportDownloadsKpiPage
